import { defineBoot } from '#q-app/wrappers'
import flagsmith from 'flagsmith'
import type { IFlags } from 'flagsmith/types'
import { ref } from 'vue'

export const flags = ref<IFlags>({})

const syncFlags = () => {
  flags.value = flagsmith.getAllFlags()
}

export default defineBoot(async () => {
  const environmentID = process.env.FLAGSMITH_ENVIRONMENT_KEY
  const api = process.env.FLAGSMITH_API_URL

  if (!environmentID) return

  await flagsmith.init({
    environmentID,
    api,
    cacheFlags: true,
    onChange: syncFlags,
  })
  syncFlags()
})
